import CloudServices from './CloudServices';

export default CloudServices;
